import { useState } from "react";
import type { Note } from "../lib/note";
import { assetIdLabel } from "../lib/pools";

export function NoteCard({ note }: { note: Note }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    await navigator.clipboard.writeText(note.raw);
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  }

  function download() {
    const blob = new Blob([note.raw + "\n"], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `tonado-note-${note.asset}-${note.amount}-${Date.now()}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="note-card" role="region" aria-label="Your deposit note">
      <header>
        <span className="note-card__pill">deposit note · keep secret</span>
        <span className="note-card__meta">
          {note.amount} {assetIdLabel(note.asset)} · {note.network}
        </span>
      </header>

      <pre className="note-card__raw" aria-label="Note text">
        <code>{note.raw}</code>
      </pre>

      <div className="note-card__actions">
        <button type="button" className="btn btn--primary btn--sm" onClick={copy}>
          {copied ? "✓ Copied" : "Copy note"}
        </button>
        <button type="button" className="btn btn--ghost btn--sm" onClick={download}>
          Download .txt
        </button>
      </div>

      <p className="note-card__warn">
        <strong>This string is bearer cash.</strong> Anyone with it can withdraw your deposit. Save
        it in a password manager and offline. Lost notes are unrecoverable.
      </p>
    </div>
  );
}
